<mat-spinner style="margin: 0 auto;"></mat-spinner>
<span>{{data}}</span>
